import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

import { ListingFilterItemInterface } from './type';

const SelectionItemDesktop = dynamic(() => import('./SelectionItemDesktop'), {
  ssr: false,
});

const SelectionItemMobile = dynamic(() => import('./SelectionItemMobile'), {
  ssr: false,
});
const SelectionItem = ({
  item,
  subTitleKey,
  value,
  onChange,
  colorSegment,
  shortDesc,
  description,
  tooltip,
}: {
  singleItemClassName?: string;
  item: ListingFilterItemInterface;
  subTitleKey: string;
  value?: boolean;
  onChange: (selected: boolean) => void;
  colorSegment?: string;
  shortDesc?: boolean;
  description?: string;
  tooltip?: string;
}) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <SelectionItemDesktop
      item={item}
      subTitleKey={subTitleKey}
      value={value}
      onChange={onChange}
      colorSegment={colorSegment}
      shortDesc={shortDesc}
      description={description}
      tooltip={tooltip}
    />
  ) : (
    <SelectionItemMobile
      item={item}
      subTitleKey={subTitleKey}
      value={value}
      onChange={onChange}
      colorSegment={colorSegment}
      shortDesc={shortDesc}
      description={description}
      tooltip={tooltip}
    />
  );
};

export default SelectionItem;
